// @flow
import React, {Component} from 'react';
import {FormattedHTMLMessage, FormattedMessage} from 'react-intl';

import Modal from '@homeaway/react-modal';
import {ButtonLink, ButtonPrimary} from '@homeaway/react-buttons';
import './SortLegalDisclaimer.less';

import type {IntlShape} from 'react-intl';

type State = {
    isOpen: boolean
};

type Props = {
    intl: IntlShape
};

export default class SortLegalDisclaimer extends Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            isOpen: false
        };
    }

    handleOpen = () => {
        this.setState({isOpen: true});
    };

    handleClose = () => {
        this.setState({isOpen: false});
    };

    render() {
        const {intl} = this.props;

        const doneButtonLabel = intl.formatMessage({
            id: 'done',
            description: 'Close modal button',
            defaultMessage: 'Done'
        });

        const legalLinkLabel = intl.formatMessage({
            id: 'sort.legal.linkText',
            description: 'link label to open legal modal',
            defaultMessage: 'Learn more'
        });

        const legalModalTitleLabel = intl.formatMessage({
            id: 'sort.legal.title',
            description: 'Legal modal caption',
            defaultMessage: 'How we determine our sort order'
        });

        const DoneButton = (
            <ButtonPrimary
                className="SortLegalDisclaimer__ModalDoneButton"
                onClick={this.handleClose}
                label={doneButtonLabel}
            />
        );

        return (
            <div className="SortLegalDisclaimer">
                <div className="SortLegalDisclaimer__legalMessage">
                    <ButtonLink
                        className="SortLegalDisclaimer__linkButton"
                        label={legalLinkLabel}
                        onClick={this.handleOpen}
                    />
                    <FormattedMessage
                        id="sort.legal.text"
                        defaultMessage="about HomeAway Sort"
                    />
                </div>
                <Modal
                    id="sortLegalModal"
                    closeText={doneButtonLabel}
                    isOpen={this.state.isOpen}
                    footer={DoneButton}
                    onClose={this.handleClose}
                    title={legalModalTitleLabel}
                >
                    <FormattedHTMLMessage
                        id="sort.legal.message"
                        description="Legal modal explanation"
                    />
                </Modal>
            </div>
        );
    }
}
